import type { RegistryEntry } from '../types';

export const viduConfigs: Record<string, RegistryEntry> = {
    // Vidu Q3 (via Wavespeed)
    'vidu-q3': {
        options: [
            { key: 'seed', label: 'Seed', type: 'number', min: 0, max: 2147483647, step: 1, group: 'basic' },
            {
                key: 'style',
                label: 'Style',
                type: 'select',
                options: [
                    { label: 'General', value: 'general' },
                    { label: 'Anime', value: 'anime' },
                ],
                default: 'general',
                group: 'basic',
            },
            {
                key: 'movement_amplitude',
                label: 'Movement Amplitude',
                type: 'select',
                options: [
                    { label: 'Auto', value: 'auto' },
                    { label: 'Small', value: 'small' },
                    { label: 'Medium', value: 'medium' },
                    { label: 'Large', value: 'large' },
                ],
                default: 'auto',
                group: 'basic',
            },
            { key: 'generate_audio', label: 'Generate Audio', type: 'switch', default: true, group: 'basic' },
            { key: 'bgm', label: 'BGM', type: 'switch', default: true, group: 'basic' },
        ],
        toProviderOptions: (ui) =>
            ({
                seed: typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? ui.seed : undefined,
                style: (() => {
                    const allowed = ['general', 'anime'] as const;
                    const raw = typeof ui.style === 'string' ? ui.style.trim() : '';
                    return (allowed as readonly string[]).includes(raw) ? raw : 'general';
                })(),
                movement_amplitude: (() => {
                    const allowed = ['auto', 'small', 'medium', 'large'] as const;
                    const raw = typeof ui.movement_amplitude === 'string' ? ui.movement_amplitude.trim() : '';
                    const v = (allowed as readonly string[]).includes(raw) ? raw : 'auto';
                    // auto: 省略，让 provider 走默认
                    return v === 'auto' ? undefined : v;
                })(),
                generate_audio: typeof ui.generate_audio === 'boolean' ? ui.generate_audio : true,
                bgm: typeof ui.bgm === 'boolean' ? ui.bgm : true,
            } as unknown as Record<string, Record<string, any>>),
    },
    // Vidu Q3 / Turbo / Pro：声画同步 + Seed
    ...Object.fromEntries(
        ['viduq3', 'viduq3-turbo', 'viduq3-pro'].map(id => [id, {
            options: [
                { key: 'audio', label: 'Audio-Visual Sync', type: 'switch', default: true, group: 'basic' },
                { key: 'seed', label: 'Seed', type: 'number', min: 0, max: 2147483647, step: 1, group: 'advanced' },
            ],
            toProviderOptions: (ui: Record<string, any>) => ({
                audio: typeof ui.audio === 'boolean' ? ui.audio : true,
                seed: typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? ui.seed : undefined,
            } as unknown as Record<string, Record<string, any>>),
        } satisfies RegistryEntry])
    ),
    'viduq4': {
        options: [
            { key: 'audio', label: 'Audio-Visual Sync', type: 'switch', default: true, group: 'basic' },
        ],
        toProviderOptions: (ui) => ({
            audio: typeof ui.audio === 'boolean' ? ui.audio : true,
        } as unknown as Record<string, Record<string, any>>),
    },
};
